import * as React from 'react';

import BaseSalesListLayout from './BaseSalesListLayout';

export default function (params) {
  return BaseSalesListLayout();
};
